import { UUID, AssigneesProjectResponseType } from '@builddocs/data-management'

import TypeRepresentative from './TypeRepresentative'

const kindsReps = [
  {
    key: 'representative_developer_inspector_sign',
    title:
      'Представитель застройщика (технического заказчика, эксплуатирующей организации или регионального оператора) по вопросам строительного контроля',
  },
  {
    key: 'representative_executor_building_sign',
    title: 'Представитель лица, осуществляющего строительство',
  },
  {
    key: 'representative_designer_sign',
    title:
      'Представитель лица, осуществляющего подготовку проектной документации',
  },
  {
    key: 'representative_executor_building_inspector_sign',
    title:
      'Представитель лица, осуществляющего строительство, по вопросам строительного контроля (специалист по организации строительства)',
  },
  {
    key: 'representative_executor_works_sign',
    title:
      'Представитель лица, выполнившего работы, подлежащие освидетельствованию',
  },
  {
    key: 'representative_other_sign',
    title: 'Представители иных лиц',
  },
]

type OwnProps = {
  assignees: AssigneesProjectResponseType[]
  selected: Record<string, UUID[]>
  selectedKey: string
  onChangeKey: (ket: string) => void
}

const RepresentationsRegistryApplication = ({
  assignees,
  selected,
  selectedKey,
  onChangeKey,
}: OwnProps) => {
  return (
    <>
      {kindsReps.map(item => (
        <TypeRepresentative
          key={item.key}
          assignees={assignees ?? []}
          kind={item.key}
          selected={selected[item.key] ?? []}
          selectedKey={selectedKey}
          title={item.title}
          onChangeKey={onChangeKey}
        />
      ))}
    </>
  )
}

export default RepresentationsRegistryApplication
